import moment from 'moment';
import 'moment/locale/it';
import { getFromLocalStorage } from './storage.util';
import { LANGUAGE } from '../constants/localstorage.constants';

export function getMonth(input: Date | string): number {
	return new Date(input).getMonth() + 1;
}

export function getYear(input: Date | string): number {
    return new Date(input).getFullYear();
}

export function formatDate(input?: Date, format?: string): string {
    if (!input) return '';
    return moment(input).locale(getFromLocalStorage(LANGUAGE)).format(format ?? 'dddd D MMMM yyyy');
}

export function formatSimpleDate(input: string): string {
    return moment(input).format('DD/MM/YYYY');
}

export function formatDateTime(input: string): string {
    return moment(input).format('DD/MM/YYYY HH:mm');
}

export function getTomorrowDate(): Date {
	const tomorrow = new Date();
	tomorrow.setDate(tomorrow.getDate() + 1);
	return tomorrow;
}

export function getSixMonthsAgoDate(): Date {
  return moment().subtract(6, 'months').toDate();
}

